function StackChart({ data }) {
    // console.log(data)
    let orange = data['negative']
    let green = data['positive']
    if (orange === 0 && green === 0) {
        return (<div className="flex flex-row w-96 ml-8 md:ml-0" >
            <div className={`relative flex justify-center h-8 bg-[#A2B5BC]`} style={{ width: "100%" }} ></div >
        </div >)
    } else {
        let total = orange + green
        let orangepercentage = Math.floor((orange / total) * 100)
        let greenpercentage = 100 - orangepercentage
        return (
            <div className="flex flex-row w-96 ml-8 md:ml-0" >
                <div className={`relative flex justify-center h-8 bg-[#EFF198]`} style={{ width: orangepercentage + "%" }} >{orangepercentage === 0 ? '' : orange + " " + "(" +  + orangepercentage + "%)"}</div >
                <div className={`relative flex justify-center h-8 bg-[#F19898]`} style={{ width: greenpercentage + "%" }}>{greenpercentage === 0 ? '' : green + " " + "(" +  greenpercentage  + "%)"}</div >
            </div >
        )
    }
}

export default StackChart